module.exports = __webpack_public_path__ + "86f4a2a2dc649c7a767367494b9bf503.svg";